import React, { useEffect } from 'react'
import { Col, Form, Dropdown, Row } from 'react-bootstrap'
import Colors from '../../../../constants/Colors'
import Modal from 'react-bootstrap/Modal'
import { fullMonthTH } from '../../../../constants/constants'
import { KYC_CUSTOMER_CITIZENSHIP, KYC_CARD_TYPE } from '../../constants'
import { getDays, getFutureYears, getYears } from '../../utils'

const KYCThaiForm = ({ cardInfo, setUserKYCData, nation }) => {
  const years = getYears(true)
  const futureYears = getFutureYears(true)

  useEffect(() => {
    if (nation === KYC_CUSTOMER_CITIZENSHIP.FOREIGNER) {
      return
    }

    setUserKYCData((prev) => ({
      ...prev,
      cardInfo: { ...prev.cardInfo, cardType: KYC_CARD_TYPE.THAI_ID },
    }))
  }, [setUserKYCData, nation])

  if (nation !== KYC_CUSTOMER_CITIZENSHIP.THAI) {
    return null
  }

  return (
    <div>
      <Row style={{ width: '100%' }}>
        <Col xs={10}>
          <Modal.Title>
            <h4 className="py-2">ข้อมูลลูกค้า (สำหรับยืนยันตัวตน)</h4>
          </Modal.Title>
        </Col>
      </Row>

      {/* Thai People */}
      <Form.Group as={Row}>
        <Form.Label column sm="3" className="">
          ชื่อ :
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            onChange={(event) =>
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, firstName: event.target.value },
              }))
            }
            value={cardInfo.firstName}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          นามสกุล :
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            value={cardInfo.lastName}
            onChange={(event) =>
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, lastName: event.target.value },
              }))
            }
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          เลขบัตรประชาชน :
        </Form.Label>
        <Col sm="9">
          <Form.Control
            maxLength={13}
            value={cardInfo.cardId}
            onChange={(event) =>
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, cardId: event.target.value },
              }))
            }
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          ที่อยู่
        </Form.Label>
        <Col sm="9">
          <Form.Control
            as="textarea"
            rows={2}
            value={cardInfo.description}
            placeholder="กรุณากรอกข้อมูล"
            className="mt-1"
            onChange={(e) => {
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, address: e.target.value },
              }))
            }}
            maxLength={220}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="my-1 align-items-center">
        <Form.Label column sm="3">
          วันเกิด (พ.ศ.)
        </Form.Label>
        <Col sm={9}>
          <Row>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        birthDate: {
                          year: value.target.value,
                          month: '',
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.birthDate.year}
                >
                  <option value="" disabled>
                    ปี
                  </option>
                  {years.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.birthDate.year}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        birthDate: {
                          ...prev.cardInfo.birthDate,
                          month: value.target.value,
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.birthDate.month}
                >
                  <option value="" disabled>
                    เดือน
                  </option>
                  {fullMonthTH.map((item, i) => (
                    <option value={i + 1} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.birthDate.month}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        birthDate: {
                          ...prev.cardInfo.birthDate,
                          day: value.target.value,
                        },
                      },
                    }))
                  }
                  value={cardInfo.birthDate.day}
                >
                  <option value="" disabled>
                    วัน
                  </option>
                  {getDays(cardInfo.birthDate.month, cardInfo.birthDate.year, true).map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="my-1 align-items-center">
        <Form.Label column sm="3">
          วันออกบัตร (พ.ศ.)
        </Form.Label>
        <Col sm={9}>
          <Row>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        issueAt: {
                          year: value.target.value,
                          month: '',
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.issueAt.year}
                >
                  <option value="" disabled>
                    ปี
                  </option>
                  {years.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.issueAt.year}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        issueAt: {
                          ...prev.cardInfo.issueAt,
                          month: value.target.value,
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.issueAt.month}
                >
                  <option value="" disabled>
                    เดือน
                  </option>
                  {fullMonthTH.map((item, i) => (
                    <option value={i + 1} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.issueAt.month}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        issueAt: {
                          ...prev.cardInfo.issueAt,
                          day: value.target.value,
                        },
                      },
                    }))
                  }
                  value={cardInfo.issueAt.day}
                >
                  <option value="" disabled>
                    วัน
                  </option>
                  {getDays(cardInfo.issueAt.month, cardInfo.issueAt.year, true).map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="my-1 align-items-center">
        <Form.Label column sm="3">
          วันหมดอายุ (พ.ศ.)
        </Form.Label>
        <Col sm={9}>
          <Row>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={cardInfo.neverExpire}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        expiredAt: {
                          ...prev.cardInfo.expiredAt,
                          year: value.target.value,
                          month: '',
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.expiredAt.year}
                >
                  <option value="" disabled>
                    ปี
                  </option>
                  {futureYears.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.expiredAt.year || cardInfo.neverExpire}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        expiredAt: {
                          ...prev.cardInfo.expiredAt,
                          month: value.target.value,
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.expiredAt.month}
                >
                  <option value="" disabled>
                    เดือน
                  </option>
                  {fullMonthTH.map((item, i) => (
                    <option value={i + 1} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.expiredAt.month || cardInfo.neverExpire}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        expiredAt: {
                          ...prev.cardInfo.expiredAt,
                          day: value.target.value,
                        },
                      },
                    }))
                  }
                  value={cardInfo.expiredAt.day}
                >
                  <option value="" disabled>
                    วัน
                  </option>
                  {getDays(cardInfo.expiredAt.month, cardInfo.expiredAt.year, true).map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Form.Group>
      <Form.Group as={Row} className="my-1 align-items-center">
        <Form.Label column sm="3" />
        <Col sm={9}>
          <Form.Check
            checked={cardInfo.neverExpire}
            label="ตลอดชีพ"
            type="checkbox"
            onChange={(e) => {
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: {
                  ...prev.cardInfo,
                  expiredAt: { year: '', month: '', day: '' },
                  neverExpire: e.target.checked,
                },
              }))
            }}
          />
        </Col>
      </Form.Group>
    </div>
  )
}

export default KYCThaiForm
